function injectStyle (ssrContext) {
  this["$style"] = require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true,\"localIdentName\":\"[hash:base64]\",\"modules\":true,\"importLoaders\":true}!../../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-1ed0238b\",\"scoped\":false,\"hasInlineConfig\":false}!less-loader?{\"sourceMap\":true}!./secondary-actions.less")
}
var normalizeComponent = require("!../../../../vue-loader/lib/component-normalizer")
/* script */
import __vue_script__ from "!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./secondary-actions.vue"
/* template */
import __vue_template__ from "!!../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1ed0238b\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../../vue-loader/lib/selector?type=template&index=0!./secondary-actions.vue"
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-components/activity-summary/components/secondary-actions/secondary-actions.vue
// module id = Qaea
// module chunks = 1